import SessionStore from './sessionStore';
import UserStore from './userStore';

class Store {
  constructor(){
    this.sessionStore = new SessionStore(this);
    this.userStore = new UserStore(this);
  }
}
const store = new Store();
export default store;



// WEBPACK FOOTER //
// ./src/stores/index.js